import { createAsyncThunk } from "@reduxjs/toolkit";
import { URLS } from "constants/api.constants";
import { axiosInstance } from "utils/axios";

export const topicsGet = createAsyncThunk('topic/topic',
    async ({ type }, {thunkAPI}) => {
        try {

            const response = await axiosInstance.get(URLS.TOPICS.GET_TOPICS, {
                
                params: { type }
            });
            if (response.data?.success) {
                return response.data;
            } else {
                return thunkAPI.rejectWithValue(response.data?.message || "Failed to fetch FAQs");

            }
        } catch (error) {
            console.log("Full error object:", error);
               return thunkAPI.rejectWithValue(error?.message || "An error occurred while fetching FAQs");

        }
    }
)